import { api } from '../../common/api';
import { getStore } from '../../store';
import { generateCheckoutUrl } from '../storefront/utils';

interface MultipassRequest {
  contactId?: string;
  salesforceId?: string;
  returnTo: string;
}

interface MultipassResponse {
  token: string;
}

function shopStoreBaseUrl(): string {
  const domain = (process.env.REACT_APP_SHOPIFY_STORE_DOMAIN ?? '').replace(/\/$/, '');
  if (!domain) return '';
  return /^https?:\/\//i.test(domain) ? domain : `https://${domain}`;
}

/**
 * Resolves to the URL the cart should redirect to.
 * - With identity in orgContext: hits Enrichly API for a Multipass token, returns the multipass URL.
 * - Without identity (or on API failure): returns the plain rewritten checkout URL.
 */
export async function getMultipassCheckoutUrl(originalCheckoutUrl: string): Promise<string> {
  const fallbackUrl = generateCheckoutUrl(originalCheckoutUrl);
  const { contactId, salesforceId } = getStore().getState().orgContext;

  if (!contactId && !salesforceId) {
    return fallbackUrl;
  }

  try {
    const body: MultipassRequest = {
      contactId,
      salesforceId,
      returnTo: fallbackUrl,
    };
    const { data } = await api.post<MultipassResponse>('/multipass', body);
    if (!data?.token) return fallbackUrl;

    const shopDomain = shopStoreBaseUrl();
    if (!shopDomain) return fallbackUrl;

    return `${shopDomain}/account/login/multipass/${data.token}?return_to=${encodeURIComponent(
      fallbackUrl
    )}`;
  } catch {
    return fallbackUrl;
  }
}
